/* @flow weak */
import cx from 'classnames';
import _ from 'lodash';
import React from 'react';

import FormCellInput from 'components/FormCellInput.jsx';
import Formsy from 'lib/Formsy';

import './styles/TableInput.scss';

const MIN_ROWS = 5;

function padRows(rows) {
  const rowLength = rows.length;
  for (let i = 0; i < MIN_ROWS - rowLength; i++) {
    rows.push({});
  }
  return rows;
}

class TableInput extends React.Component {
  static propTypes = {
    columns: React.PropTypes.arrayOf(React.PropTypes.shape({
      name: React.PropTypes.string.isRequired,
      label: React.PropTypes.string.isRequired,
      placeholder: React.PropTypes.any,
      placeholders: React.PropTypes.arrayOf(React.PropTypes.string),
      validations: React.PropTypes.any,
      validationError: React.PropTypes.any,
      validationErrors: React.PropTypes.any,
    })),
    onChangeRow: React.PropTypes.func,
    initialRows: React.PropTypes.array,
    autofocusFirstRow: React.PropTypes.bool,
  };

  static defaultProps = {
    initialRows: [],
  };

  state = {
    rows: padRows(this.props.initialRows),
    shouldScroll: false,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.initialRows.length !== this.state.rows.length) {
      this.setState({ rows: padRows(nextProps.initialRows) });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.rows.length !== this.state.rows.length) {
      this.setState({ rows: padRows(nextState.rows) });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.shouldScroll) {
      const tableContainer = this.refs.tableContainer;
      tableContainer.scrollTop = tableContainer.scrollHeight;
    }

    if (JSON.stringify(prevState) === JSON.stringify(this.state)) {
      return;
    }

    prevState.rows.forEach((row, i) => {
      if (!this.state.rows[i]) {
        return;
      }
      if (!_.isEmpty(row.fields) && _.isEmpty(this.state.rows[i].fields)) {
        this.refs['form-' + i].reset();
      }
    });
  }

  setRowValid = (rowIndex, isValid) => {
    const rows = this.state.rows.slice(0);
    rows[rowIndex].isValid = isValid;
    this.setState({ rows });
    if (this.props.onChangeRow) {
      this.props.onChangeRow(rows);
    }
  };

  changeInputState = (rowIndex, name, event) => {
    const rows = this.state.rows.slice(0);
    if (!rows[rowIndex].fields) {
      rows[rowIndex].fields = {};
    }
    rows[rowIndex].fields[name] = event.target.value;
    if (rows[rowIndex].validation_errors) {
      delete rows[rowIndex].validation_errors[name];
    }

    let shouldScroll = false;
    if (rowIndex === (this.state.rows.length - 1)) {
      rows.push({});
      shouldScroll = true;
    }

    this.setState({ rows, shouldScroll });
    if (this.props.onChangeRow) {
      this.props.onChangeRow(rows);
    }
  };

  renderTableBody = () => {
    const rowItems = this.state.rows.map((row, rowIndex) => {
      const fieldErrors = row.validation_errors || [];
      const tableCells = this.props.columns.map((column, columnIndex) => {
        const { name, label, placeholder, placeholders, validations, validationError, validationErrors } = column;
        const key = `${name}-${rowIndex}`;
        const value = row.fields && row.fields[name];
        const placeholderText = placeholders
          ? placeholders[rowIndex % placeholders.length]
          : placeholder || label;
        return (
          <span key={key} className="TableInput-body-cell TableInput-cell">
            <FormCellInput
              onChange={this.changeInputState.bind(this, rowIndex, name)}
              value={value || ''}
              placeholder={placeholderText}
              validations={validations}
              validationError={validationError}
              validationErrors={validationErrors}
              name={key}
              errorMessage={fieldErrors[name] || null}
              autofocus={rowIndex === 0 && columnIndex === 0 && this.props.autofocusFirstRow}
            />
          </span>
        );
      });
      return (
        <Formsy.Form
          key={rowIndex}
          ref={'form-' + rowIndex}
          className="TableInput-body-row"
          onValid={() => this.setRowValid(rowIndex, true)}
          onInvalid={() => this.setRowValid(rowIndex, false)}>
          <span className="TableInput-cell--validation TableInput-cell" />
          {tableCells}
        </Formsy.Form>
      );
    });

    return rowItems;
  };

  renderColumnNames = () => {
    const headerItems = this.props.columns.map(col => (
      <div className="TableInput-headerRow-cell TableInput-cell" key={col.name}>
        {col.label}
      </div>
    ));
    return (
      <div className="TableInput-headerRow">
        <span className="TableInput-cell--validation TableInput-cell" />
        {headerItems}
      </div>
    );
  };

  render() {
    return (
      <div className={cx('TableInput', this.props.className)}>
        {this.renderColumnNames()}
        <div className="TableInput-container" ref="tableContainer">
          <div className="TableInput-body">{this.renderTableBody()}</div>
        </div>
      </div>
    );
  }
}

export default TableInput;



// WEBPACK FOOTER //
// ./src/components/TableInput.jsx